import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import Header from 'modules/layout/components/Page/Header'
import { usePolicyPeriods } from 'modules/payroll_bundle/lib/policyPeriodsContext'
import { usePolicies } from 'modules/payroll_bundle/store/collections/policies'

interface Props {
  companyId: string
}

const PayrollPoliciesTabs = ({ companyId }: Props) => {
  const policies = usePolicies()
  const { navigation } = useNavigation()
  const { policyPeriodCollection } = usePolicyPeriods()

  const policiesTabs = useUnsafeMemo(() => {
    return policies.filter({ company_id: companyId }).map((policy) => {
      const period = policyPeriodCollection.find({ policy_id: policy.get('id') })
      const link =
        navigation.bookkeepers.clients.payrollResults.payrollPolicy.payrollPolicyPeriodId.fullPath({
          periodId: period?.attributes.id,
          policyId: policy.get('id')!,
        })

      return {
        index: true,
        name: policy.get('name'),
        href: link,
      }
    })
  }, [companyId, policies, policyPeriodCollection])

  return (
    <Box width="full">
      <Header.Tabs tabs={policiesTabs} />
    </Box>
  )
}

export default observer(PayrollPoliciesTabs)
